import React, { useState, useEffect } from 'react';
import FourPillars from '../components/FourPillars';

const NonprofitPage = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'why-choose',
        'solutions',
        'key-benefits'
      ];
      
      const scrollPosition = window.scrollY + 150;
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };

  return (
    <main className="services">
      <div className="container">
        <div className="sv-content-wrapper">
          <div className="sv-main-content">
            {/* Hero */}
            <section className="sv-hero">
              <div className="sv-eyebrow">Nonprofit & Charity</div>
              <h1 className="sv-title">Supporting Mission-Driven Organizations with Asset Recovery Solutions</h1>
              <p className="sv-subtitle">Specialized solutions for nonprofit and charitable organizations to maximize the impact of donated goods, manage excess inventory, and optimize operations. Professional sorting, tracking, and redistribution to extend your reach efficiently.</p>
            </section>

            {/* Why Choose */}
            <section id="why-choose" className="sv-features">
              <h2 className="sv-section-title">Why Nonprofit & Charity Organizations Choose Us</h2>
        <div className="sv-features-grid">
          <div className="sv-feature">
            <h4>Mission Alignment</h4>
            <p>Support your mission with solutions designed to maximize community impact and operational efficiency.</p>
          </div>
          <div className="sv-feature">
            <h4>Donation Management</h4>
            <p>Professional sorting, tracking, and redistribution of donated goods to maximize community benefit.</p>
          </div>
          <div className="sv-feature">
            <h4>Tax Credit Support</h4>
            <p>Comprehensive documentation and support for tax credit purposes to maximize donor benefits.</p>
          </div>
          <div className="sv-feature">
            <h4>Vetted Partnerships</h4>
            <p>Partnerships with vetted organizations and networks to ensure maximum impact and accountability.</p>
          </div>
        </div>
      </section>

            {/* Solutions */}
            <section id="solutions" className="sv-overview">
              <h2 className="sv-section-title">Solutions for Nonprofit & Charity Organizations</h2>
        <ul className="sv-bullets sv-list">
          <li>Donation Management – Professional sorting, tracking, and redistribution of donated goods</li>
          <li>Excess Inventory – Manage and redistribute excess inventory to maximize community impact</li>
          <li>Tax Credit Support – Comprehensive documentation and support for donor tax benefits</li>
          <li>Community Distribution – Strategic routing of goods to communities in need</li>
          <li>Operational Efficiency – Streamline operations to focus resources on mission-critical activities</li>
          <li>Impact Reporting – Detailed reporting and analytics to demonstrate community impact</li>
        </ul>
      </section>

            {/* Benefits */}
            <section id="key-benefits" className="sv-overview">
              <h2 className="sv-section-title">Key Benefits</h2>
        <ul className="sv-bullets sv-list">
          <li>Maximize community impact through efficient donation management</li>
          <li>Support donor tax benefits with comprehensive documentation</li>
          <li>Extend reach through strategic redistribution networks</li>
          <li>Improve operational efficiency to focus on mission</li>
          <li>Ensure accountability with detailed tracking and reporting</li>
          <li>Build partnerships with vetted organizations and networks</li>
        </ul>
      </section>

            {/* Four Pillars */}
            <FourPillars />

            {/* CTA */}
            <section className="sv-cta">
              <div className="sv-cta-inner">
                <h3>Ready to empower your mission?</h3>
                <p>Do more with donations while staying compliant and efficient. Get a free assessment today.</p>
                <div className="sv-cta-actions">
                  <a className="btn btn-primary" href="tel:+18778739336">Call (877) 873-9336</a>
                  <a className="btn btn-secondary" href="mailto:info@globoflo.com">Email Us</a>
                </div>
              </div>
            </section>
          </div>

          {/* Quick Links Sidebar */}
          <aside className="sv-quick-links">
            <h3 className="sv-quick-links-title">Nonprofit & Charity</h3>
            <nav className="sv-quick-links-nav">
              <ul>
                <li>
                  <button 
                    className={activeSection === 'why-choose' ? 'active' : ''}
                    onClick={() => scrollToSection('why-choose')}
                  >
                    Why Nonprofit & Charity Organizations Choose Us
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'solutions' ? 'active' : ''}
                    onClick={() => scrollToSection('solutions')}
                  >
                    Solutions for Nonprofit & Charity Organizations
                  </button>
                </li>
                <li>
                  <button 
                    className={activeSection === 'key-benefits' ? 'active' : ''}
                    onClick={() => scrollToSection('key-benefits')}
                  >
                    Key Benefits
                  </button>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default NonprofitPage;


